import { useEffect, useState } from 'react';
import { useI18n } from 'src/utils/lni18n';
import classes from "./partlist.module.scss";
import { IdAndNameDto } from 'src/types';
import { atom, useAtom } from 'jotai';
import coursePartService, { authorsAtom, partByAuthorAtom } from 'src/coursepart/CoursePartService';
import { PartSmallDragging } from './PartSmallDragging';
import { PartWithThumbnail } from '../domain/CourseEditModel';
import UserAsyncFind, { selectedUserAtom } from 'src/components/UserAsyncFind';
import { userService } from 'src/services/user/userService';
import { UserMailDto } from 'src/services/user/types';
import LnIcon from 'src/components/LnIcon';

const selectedAuthorAtom = atom<IdAndNameDto | undefined>(undefined);
const filterTextAtom = atom<string>("");

const CoursePartFindByAuthor = (props: { themeParts: Record<string, boolean>, onContextMenu: (e: React.MouseEvent, part: PartWithThumbnail) => void }) => {

    const { themeParts, onContextMenu } = props;
    const { languageService: t } = useI18n();

    const [selectedAuthor, setSelectedAuthor] = useAtom(selectedAuthorAtom);
    const [loadingAuthor, setLoadingAuthor] = useState<boolean>(false);
    const [filterText, setFilterText] = useAtom(filterTextAtom);
    const [filteredItems, setFilteredItems] = useState<PartWithThumbnail[]>([]);

    const [selectedUser, setSelectedUser] = useAtom(selectedUserAtom);

    const [items] = useAtom(partByAuthorAtom);

    useEffect(() => {
        if (items?.length > 0) {
            if (filterText.length > 1) {
                const searchText = filterText.toLowerCase();
                setFilteredItems(items.filter(i => i.Name.toLowerCase().indexOf(searchText) > -1));
            }
            else {
                setFilteredItems(items);
            }
        }
        else{
            setFilteredItems([]);
        }
    }, [items, filterText])

    const authorSelected = async ( user: UserMailDto | undefined) => {

        if (user === undefined || !user.Id ) {
            setSelectedAuthor(undefined);
            return;
        }

        setSelectedAuthor( {Id: user.Id, Name: `${user.FullName} (${user.Mail})`} );
        setLoadingAuthor(true);
        try {
            await coursePartService.getPartsByAuthor(user.Id);
        }
        catch (error) {
            console.error("Error fetching parts by author:", error);
        }
        finally {
            setLoadingAuthor(false);
        }

    }
    const userSearch = async (query: string) => {
        const users = await userService().findUsers(query, "type", "teachers");

        return users && users.map((i: any) => ({
            Mail: i.Mail,
            Initials: i.Initials,
            Id: i.Id,
            FullName: i.FullName
        })) || [];
    };


    function clearList() {
        coursePartService.clearPartsByAuthor();
        setSelectedAuthor(undefined);
        setFilterText("");
        setSelectedUser([]);
    }

    return <>
        <div className='max-col-width d-flex align-items-center'>
            <UserAsyncFind className='flex-fill' dropUp={true} positionFixed={true} focus={true} onUserSelected={authorSelected} userSearch={userSearch} />
            <button title={t.getText("reset")} onClick={clearList} type='button' className='ml-3 btn btn-primary btn-small' ><LnIcon name="cross" className='filter-white icon-small' /></button>
            

        </div>

        {!loadingAuthor && selectedAuthor &&
            <>

                { items && items.length > 10 &&
                    <div className='my-3'>
                        <input value={filterText} type="text" onChange={(e) => setFilterText(e.target.value)} placeholder={t.getText("filter")} className="max-col-width input form-control" />
                    </div>
                }
                <div className='small mb-2'><strong>{t.getText("owner")}:</strong> {selectedAuthor?.Name}</div>

                <div className={`mt-3 d-flex flex-wrap ${classes.coursePartList}`} aria-live="polite">


                    {filteredItems.map(p =>
                        <PartSmallDragging onContextMenu={(e) => onContextMenu(e, p)} notDraggable={themeParts[p.Id] !== undefined} key={p.Id} part={p} />
                    )}

                </div>
            </>
        }
    </>
}


export default CoursePartFindByAuthor;